export const COPYRIGHT_TEXT =
  '© 2012-2026 Committee for Children. Second Step® is a registered trademark of Committee for Children.'
